let a;

const MIME_TYPE = {
  'zip': 'application/zip',
  'pdf': 'application/pdf',
  'doc': 'application/msword',
  'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'xls': 'application/vnd.ms-excel',
  'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'ppt': 'application/vnd.ms-powerpoint',
  'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'xml': 'application/xml',
  'txt': 'text/plain',
  'html': 'text/html'
};

const initDownloadLink = () => {
  if (a) {
    return;
  }

  a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  a.className = 'js-save-file';
};

const fromBlob = (blob, filename, fileExt) => {
  const fullFileName = (fileExt) ? `${filename}.${fileExt}` : filename;

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, fullFileName);
  } else {
    initDownloadLink();

    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = fullFileName;
    a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
  }
};

const fromUrl = (url, filename, token, ext) => {
  let deferred = Promise;
  const xhr = new XMLHttpRequest();
  let fileName = filename;
  let fileExt = ext;

  xhr.open('GET', url, true);
  xhr.responseType = 'arraybuffer';

  if (token) {
    xhr.setRequestHeader('Authorization', token);
    xhr.withCredentials = true;
  }

  xhr.onabort = xhr.onerror = deferred.reject();
  xhr.onload = () => {
    if (!fileName || !fileExt) {
      ( {fileName, fileExt} = parseContentDispositionHeader(xhr) );
    }

    const blob = new Blob([xhr.response], {type: MIME_TYPE[fileExt.toLowerCase()]});

    fromBlob(blob, fileName, fileExt);
    deferred.resolve();
  };

  xhr.send();

  return deferred;
};

async function handleDownload(url,filename) {
  try {
    const response = await fetch(url, { credentials:'include' });
    if(!response.ok) 
      throw new Error(`Cannot download PDF: ${response.status}`);

    const blob = await response.blob();
    const link = await window.URL.createObjectURL(blob);
    initDownloadLink();
    a.href = link;
    a.target = "_blank"
    a.download = filename;
    document.body.appendChild(a); 
    a.click();    
    a.remove();     
  } catch(error) {
    console.log(error);
  }
}




const parseContentDispositionHeader = (xhr) => {
  const content = xhr.getResponseHeader('Content-Disposition');
  const decodedContent = decodeURI(`${content}`);
  const headerPattern = /filename\*=UTF-8''([^.]*).([A-z]*$)/;
  const result = decodedContent.match(headerPattern);
  const fileName = result && result[1] ? result[1] : 'Document';
  const fileExt = result && result[2] ? result[2] : 'zip';

  return {
    fileName,
    fileExt
  };
};

export {fromUrl, fromBlob, handleDownload};